module.exports = __webpack_public_path__ + "media/images/lp_consultation/message-device-small-b068c86d490f756c748af105864eb52a.png";